module.exports = __webpack_public_path__ + "img/logo.1f955b6f.png";